import { createAsyncThunk } from "@reduxjs/toolkit";

import { handleFetch } from "src/api";
import { CareerType } from "src/shared/config";
import { endPoints } from "src/shared/model";
import { RootState } from "src/app/model/store";

export const getCareers = createAsyncThunk<CareerType[]>(
  "careers/getCareers",
  async () => {
    const response = await handleFetch<undefined, { success: CareerType[] }>({
      url: endPoints.careers,
      method: "GET",
    });

    return response.success;
  },
);

export const createCareer = createAsyncThunk<CareerType[]>(
  "careers/createCareer",
  async (_, { getState }) => {
    const state = getState() as RootState;
    const newCareer = state.careers.newCareer;

    const response = await handleFetch<CareerType, { success: CareerType[] }>({
      url: endPoints.careers,
      method: "POST",
      data: { ...newCareer },
    });

    return response.success;
  },
);
